/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_CITIES } from "../graphql/getCities.query";

const is = require("is_js");
const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCitiesMethods extends IPluginMethodMap {
    getCities(): Promise<any>;
}

export class GetCitiesService implements IAgentPlugin {
    readonly methods: IGetCitiesMethods;
    private exchangeRate: any = 1;

    constructor() {
        this.methods = {
            getCities: this.getCities.bind(this),
        };
    }

    async getCities() {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_CITIES,
                    variables: {},
                    fetchPolicy: "network-only",
                });
                const formattedData = Object.entries(res?.data?.getCities?.cities?.data).map(
                    ([key, value]) => ({
                        label: key,
                        value: key,
                    })
                );
                console.log(formattedData);
                return {
                    citiesOptions: formattedData
                };
                // return [];
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }
}
